<script setup lang="ts">
import { useModalPageWrapper } from '@modules/core/components/ModalPageWrapper/composables';
import ModalPageWrapper from '@modules/core/components/ModalPageWrapper/ModalPageWrapper.vue';

import type { ITrackerDealChangesModalPageProps } from './types';
import TrackerDealChangesPage from '../TrackerDealChangesPage/TrackerDealChangesPage.vue';

defineProps<ITrackerDealChangesModalPageProps>();

const { showPageDialog, closePageDialog } = useModalPageWrapper();
</script>

<template>
  <div v-data-qa-auto-id="'TrackerDealChangesModalPage'">
    <ModalPageWrapper
      :show-dialog="showPageDialog"
      :back-to="backTo"
      @hide="closePageDialog"
    >
      <TrackerDealChangesPage
        :edit-history-route="editHistoryRoute"
        :back-from-edit-history-route="backFromEditHistoryRoute"
        :trackers-list-query-key="trackersListQueryKey"
      />
    </ModalPageWrapper>
  </div>
</template>
